import { Pipe, PipeTransform } from '@angular/core';
import { ActorType } from '../../shared/datamodel';

/**
 * Pipe to return the icon class to use for an entity type.
 */
@Pipe({
    name: 'entityIcon',
    standalone: false
})
export class EntityIconPipe implements PipeTransform {
  transformer = {
    [ActorType.ORGANISATION]: 'fa-building',
    [ActorType.OGU_ORGANISATION]: 'fa-home',
    [ActorType.OFFICE]: 'fa-chair-office'
  };
  transform(actorType: ActorType): string {
    return this.transformer[actorType] ?? 'fa-bug';
  }
}
